import { render, staticRenderFns } from "./RelationshipEdit.vue?vue&type=template&id=55ce181c&scoped=true"
import script from "./RelationshipEdit.vue?vue&type=script&lang=js"
export * from "./RelationshipEdit.vue?vue&type=script&lang=js"
import style0 from "./RelationshipEdit.vue?vue&type=style&index=0&id=55ce181c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce181c",
  null
  
)

export default component.exports